import styles from "./ChatHandlePane.module.scss";

export interface Props {
  isStreaming: boolean;
  onRegenerateClicked: () => void;
  onStopGenerateClicked: () => void;
}

export function ChatHandlePane(props: Props) {
  return (
    <div className={styles.container}>
      {!props.isStreaming ? (
        <div className={styles.handleButton} onClick={() => props.onRegenerateClicked()}>
          <span className={styles.handleImage}>
            <ChatHandleRegenerate />
          </span>
          <span className={styles.handleText}>Regenerate</span>
        </div>
      ) : null}
      {props.isStreaming ? (
        <div className={styles.handleButton} onClick={() => props.onStopGenerateClicked()}>
          <span className={styles.handleImage}>
            <ChatHandleStartNew />
          </span>
          <span className={styles.handleText}>Stop Generating</span>
        </div>
      ) : null}
    </div>
  );
}

/// Regenerate 图标
function ChatHandleRegenerate() {
  // 👇️ 将 SVG 粘贴到组件中
  // 将 fill 和 stroke 颜色作为属性
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_2169_43313)">
        <rect width="20" height="20" rx="10" transform="matrix(-1 0 0 1 20 0)" fill="#020C26" fillOpacity="0.1" />
        <path
          d="M5.00488 8.88889C5.00488 8.88889 6.11876 7.37123 7.02368 6.46569C7.9286 5.56015 9.1791 5 10.5604 5C13.3219 5 15.5604 7.23858 15.5604 10C15.5604 12.7614 13.3219 15 10.5604 15C9.43461 15 8.3957 14.6279 7.55995 14M5.00488 8.88889V5.55556M5.00488 8.88889H8.33822"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2169_43313"
          x="-40"
          y="-40"
          width="100"
          height="100"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2169_43313" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2169_43313" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

/// StartNew 图标
function ChatHandleStartNew() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_2169_43288)">
        <rect width="20" height="20" rx="10" transform="matrix(-1 0 0 1 20 0)" fill="#020C26" fillOpacity="0.1" />
        <rect width="8" height="8" rx="1.5" transform="matrix(-1 0 0 1 14 6)" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_b_2169_43288"
          x="-40"
          y="-40"
          width="100"
          height="100"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2169_43288" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2169_43288" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
